
import { Component, Directive, Input } from "@angular/core";
import { NavController } from 'ionic-angular';

import { ExerciseListPage } from '../../pages/exercises/exercise-list';
import { ActivityRoutineListPage } from '../../pages/exercises/activity-routine-list';

@Component({
  selector: 'exercise-tabs',
  templateUrl: 'exercise-tabs.html',
})
@Directive({
  selector: "exercise-tabs"
})
export class ExerciseTabs {
  @Input('page') page: string;

  constructor(
    private navCtrl: NavController) {
  }

  doOpenPage() {
    switch(this.page) {
      case 'exercises':
        this.navCtrl.setRoot(ExerciseListPage);
        break;
      case 'routines':
        this.navCtrl.setRoot(ActivityRoutineListPage);
        break;
    }
  }

}


// WEBPACK FOOTER //
// ./src/components/exercise-tabs/exercise-tabs.ts